import { HomeConfig } from "./types";

export const DEFAULT_HOME_CONFIG: HomeConfig = {
  layout: {
    type: "two-column",
    columnRatios: ["2", "1"],
  },
  banner: {
    enabled: true,
    title: "Welcome",
    icon: "home",
  },
  sections: [],
  plugins: [],
  settings: {
    showAll: true,
    maxWidth: "7xl",
    spacing: 6,
  },
};

/**
 * Generates default sections and widgets based on current hardcoded components
 */
export function generateDefaultSections(): HomeConfig {
  return {
    ...DEFAULT_HOME_CONFIG,
    plugins: [
      {
        id: "favorites",
        title: "⭐ Favorites",
        column: "right",
        priority: 400,
        enabled: true,
      },
    ],
    sections: [
      // Developer Tools section
      {
        id: "developer-tools",
        type: "tools",
        title: "Developer Tools",
        column: "left",
        priority: 10,
        enabled: true,
        grid: {
          columns: 6,
          gap: 4,
        },
        items: [
          {
            title: "GitLab",
            icon: "git-branch",
            color: "bg-orange-500",
            url: "https://gitlab.com",
            openInNewTab: true,
          },
          {
            title: "Jira",
            icon: "check-circle",
            color: "bg-blue-500",
            url: "https://www.atlassian.com/software/jira",
            openInNewTab: true,
          },
          {
            title: "Stack Overflow",
            icon: "help-circle",
            color: "bg-orange-400",
            url: "https://stackoverflow.com",
            openInNewTab: true,
          },
          {
            title: "Confluence",
            icon: "file-text",
            color: "bg-blue-600",
            url: "https://www.atlassian.com/software/confluence",
            openInNewTab: true,
          },
          {
            title: "SonarQube",
            icon: "code-2",
            color: "bg-blue-400",
            url: "https://www.sonarsource.com/products/sonarqube/",
            openInNewTab: true,
          },
          {
            title: "Sentry",
            icon: "bug",
            color: "bg-purple-600",
            url: "https://sentry.io",
            openInNewTab: true,
          },
          {
            title: "Asana",
            icon: "list-todo",
            color: "bg-red-500",
            url: "https://asana.com",
            openInNewTab: true,
          },
          {
            title: "CNX",
            icon: "box",
            color: "bg-gray-600",
            url: "https://www.cnx.org",
            openInNewTab: true,
          },
          {
            title: "Figma",
            icon: "palette",
            color: "bg-purple-500",
            url: "https://www.figma.com",
            openInNewTab: true,
          },
          {
            title: "Artifactory",
            icon: "package",
            color: "bg-green-600",
            url: "https://jfrog.com/artifactory/",
            openInNewTab: true,
          },
          {
            title: "Wiz",
            icon: "shield",
            color: "bg-blue-700",
            url: "https://www.wiz.io",
            openInNewTab: true,
          },
        ],
      },
      // Corporate Tools section
      {
        id: "corporate-tools",
        type: "tools",
        title: "Corporate Tools",
        column: "left",
        priority: 20,
        enabled: true,
        grid: {
          columns: 6,
          gap: 4,
        },
        items: [
          {
            title: "Book a desk",
            icon: "calendar",
            color: "bg-gray-600",
            url: "https://example.com/desk-booking",
            openInNewTab: true,
          },
          {
            title: "Recognise a colleague",
            icon: "trophy",
            color: "bg-yellow-500",
            url: "https://example.com/recognition",
            openInNewTab: true,
          },
          {
            title: "ServiceNow",
            icon: "headphones",
            color: "bg-green-600",
            url: "https://www.servicenow.com",
            openInNewTab: true,
          },
          {
            title: "Clarity",
            icon: "bar-chart-3",
            color: "bg-blue-500",
            url: "https://example.com/clarity",
            openInNewTab: true,
          },
          {
            title: "Workday",
            icon: "users",
            color: "bg-orange-500",
            url: "https://www.workday.com",
            openInNewTab: true,
          },
          {
            title: "Connect",
            icon: "network",
            color: "bg-purple-500",
            url: "https://example.com/connect",
            openInNewTab: true,
          },
        ],
      },
      // Useful Links section
      {
        id: "useful-links",
        type: "links",
        title: "🔗 Useful Links",
        column: "right",
        priority: 10,
        enabled: true,
        grid: {
          columns: 2,
          gap: 4,
        },
        items: [
          {
            title: "Engineering Learning & Career",
            description: "Development hub",
            icon: "🎓",
            url: "https://example.com/learning",
            openInNewTab: true,
          },
          {
            title: "Technology Support Hub",
            icon: "💻",
            url: "https://example.com/tech-support",
            openInNewTab: true,
          },
          {
            title: "Cloud Learning",
            description: "Learn and master everything in LSEG Cloud",
            icon: "☁️",
            url: "https://example.com/cloud-learning",
            openInNewTab: true,
          },
          {
            title: "Service Now",
            icon: "🔧",
            url: "https://www.servicenow.com",
            openInNewTab: true,
          },
          {
            title: "Front Door",
            description: "Support for Developers",
            icon: "🚪",
            url: "https://example.com/front-door",
            openInNewTab: true,
          },
          {
            title: "Developer Desktops",
            icon: "🖥️",
            url: "https://example.com/desktops",
            openInNewTab: true,
          },
        ],
      },
    ],
  };
}
